import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { TraitTypeSelectMultiple } from '../traitTypes/TraitTypeSelectMultiple';
export class TraitRegistryMediaPlaybackSettings extends TraitRegistryCategory {
    label = 'Abspiel-Eigenschaften';
    constructor(parent) {
        super(parent);
        super.init();
    }
    playbackVolume = () => new TraitTypeNumericWithSlider({
        label: 'Lautstärke',
        default: 1,
        init: 1,
        min: 0,
        max: 1,
        step: 0.01,
    });
    playbackRate = () => new TraitTypeNumericWithSlider({
        label: 'Geschwindigkeit',
        default: 1,
        init: 1,
        min: 0.1,
        max: 10,
        step: 0.01,
    });
    playbackChannel = () => new TraitTypeSelect({
        label: 'Kanal',
        default: 'voice',
        select: [
            ['voice', 'Sprache'],
            ['sound', 'Sound'],
            ['background', 'Hintergrundmusik'],
        ],
    });
    playbackStartConditions = () => new TraitTypeSelectMultiple({
        default: ['isChannelFree_voice', 'isSilenceSince_0.5', 'isSilenceSince_1'],
        /*  label: 'Startbedingung (und)',
      default: ['isChannelFree_voice', 'isSilenceSince_1'],
      select: [
        ['isChannelFree_voice', 'Kanal Sprache frei'],
        ['isChannelFree_sound', 'Kanal Sound frei'],
        ['isChannelFree_background', 'Kanal Hintergrundmusik frei'],
        ['isSilenceSince_1', '1 Sekunde Stille']
      ] */
    });
    playbackAbortConditions = () => new TraitTypeSelectMultiple({
        default: ['isAlreadyPlaying'],
        /* label: 'Abbruchbedingung (und)',
      select: [
        ['isAlreadyPlaying', 'Spielt bereits'],
        ['isConditionGone', 'Nicht mehr gültig'],
        ['isOtherWaiting', 'Anderes Medium möchte Kanal']
      ] */
    });
    playbackAbortRunning = () => new TraitTypeSelectMultiple({
        label: 'Stoppe laufende',
        default: [],
        select: [
            ['voice', 'Sprache'],
            ['sound', 'Sounds'],
            ['background', 'Hintergründe'],
        ],
    });
    playbackAbortQueued = () => new TraitTypeSelectMultiple({
        label: 'Stoppe anstehende',
        default: [],
        select: [
            ['voice', 'Sprache'],
            ['sound', 'Sounds'],
            ['background', 'Hintergründe'],
        ],
    });
    playbackLoop = () => new TraitTypeSelect({
        label: 'Wiederholen',
        default: 0,
        select: [
            [0, 'nein'],
            [1, '1x'],
            [2, '2x'],
            [9999, 'endlos'],
        ],
    });
}
